import { PropTypes } from "prop-types";

export const AuthPagePaper = ({ children }) => {
  return <section className="AuthPagePaper">{children}</section>;
};

AuthPagePaper.propTypes = {
  children: PropTypes.node,
};
